import React from "react";
import {
  Box,
  Button,
  List,
  ListItem,
  Typography,
  TextField,
} from "@mui/material";

const QuantityEntryStep = ({
  selectedProducts,
  productQuantities,
  onQuantityChange,
  onSave,
  canSave,
}) => {
  const handleQuantityInputChange = (productFormatId, value) => {
    // Only allow numbers, dots, and commas
    const sanitized = value.replace(/[^0-9.,]/g, "");
    onQuantityChange(productFormatId, sanitized);
  };

  return (
    <>
      <Box
        sx={{
          maxHeight: "400px",
          overflow: "auto",
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[300],
          borderRadius: 1,
          marginBottom: 4,
        }}
      >
        <List disablePadding>
          {selectedProducts.map((product) => (
            <ListItem
              key={product.productFormatId}
              sx={{
                backgroundColor: (theme) => theme.palette.terrain[50],
                borderBottom: "1px solid",
                borderColor: (theme) => theme.palette.terrain[300],
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 2,
                gap: 2,
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  variant="body1"
                  sx={{
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {product.displayName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {product.unit || ""}
                </Typography>
              </Box>
              <Box sx={{ flexShrink: 0, minWidth: "100px" }}>
                <TextField
                  size="small"
                  placeholder="0.00"
                  value={productQuantities[product.productFormatId] || ""}
                  onChange={(e) =>
                    handleQuantityInputChange(
                      product.productFormatId,
                      e.target.value
                    )
                  }
                  fullWidth
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    "& .MuiOutlinedInput-root": {
                      background: (theme) => theme.palette.pure.white,
                    },
                    "& input": {
                      textAlign: "center",
                    },
                    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                  }}
                  error={
                    productQuantities[product.productFormatId] === undefined ||
                    productQuantities[product.productFormatId] === ""
                  }
                />
              </Box>
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Save Button */}
      <Box sx={{ marginTop: 4 }}>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={!canSave}
          fullWidth
          sx={{ height: 48 }}
        >
          Add Products
        </Button>
      </Box>
    </>
  );
};

export default QuantityEntryStep;
